/*
 * @Author: changcheng
 * @LastEditTime: 2023-03-24 10:20:30
 */
import { Button, Form, Input, message, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import axios from "@/axios/axios";
interface valueTypes {
  mobile: string;
  cardNo: string;
  cardPassword: string;
}
export const OnlineCardBind = () => {
  const [form] = Form.useForm();
  const onFinish = async (values: valueTypes) => {
    const { cardNo, cardPassword, mobile } = values;
    const { code, msg, data } = await axios.post(
      "/shop/front/ce/item/card/check",
      {
        cardNo,
        cardPassword,
      }
    );
    if (code === 0) {
      const { creditValue } = data;
      Modal.confirm({
        title: "绑卡确认",
        icon: <ExclamationCircleOutlined />,
        content: `确认给${mobile}绑定${creditValue}学分，一经绑定，无法取消`,
        okText: "确认",
        cancelText: "取消",
        onOk: async () => {
          const { data, code, msg } = await axios.post(
            `/shop/front/ce/user/bind/card`,
            values
          );
          if (code === -1) {
            message.info(msg);
          } else {
            message.success(msg);
            form.resetFields();
          }
        },
      });
    } else {
      message.error(msg);
    }
  };
  return (
    <div>
      <h2>在线绑卡</h2>
      <p>
        提示：学习卡为消费型卡，一经绑定相当于消费，请您先谨慎核对好您的用户信息后再进行绑定。
        绑定后在学习记录中进行查看。
      </p>
      <Form
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
        style={{
          width: "300px",
        }}
        form={form}
      >
        <Form.Item
          label="手机号码"
          name="mobile"
          rules={[{ required: true, message: "请输入手机号码" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="卡号"
          name="cardNo"
          rules={[{ required: true, message: "请输入卡号" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="密码"
          name="cardPassword"
          rules={[{ required: true, message: "请输入密码" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            绑定确认
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
